export function loadFacebookPixel({ pixelId }) {
  // Make sure we only initialize the pixel once.
  let fbq = window.fbq;
  if (fbq) {
    return fbq;
  }

  // Integration code provided by Facebook
  // After this function runs, window.fbq will be defined
  // and should be returned to the caller.
  const load = function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  };

  load(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js',
  );

  // Initialize the pixel before returning it.
  // We are disabling automatice page view events because the pixel is
  // not always loaded, so for now the page view events would be unreliable.
  fbq = window.fbq;
  fbq.disablePushState = true;
  fbq('init', pixelId);

  return fbq;
}
